module.exports = __webpack_public_path__ + "static/img/cns-1.f2dd350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cns-1.jpg
// module id = 30fR
// module chunks = 0